module.exports = __webpack_public_path__ + "img/img_60.4df841cd.png";